import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import WebsiteLayout from '../../components/Website/WebsiteLayout';
import HeroSection from '../../components/Website/HeroSection';
import SEO from '../../components/SEO/SEO';

const DPAPage = () => {
    return (
        <WebsiteLayout>
            <SEO title="Data Processing Agreement - Flux IT Studio" description="DPA for Flux ERP business customers" />
            <HeroSection>
                <Box sx={{ textAlign: 'center', maxWidth: 800, mx: 'auto' }}>
                    <Typography variant="h1" sx={{ fontSize: { xs: 40, md: 56 }, fontWeight: 800, mb: 3, color: 'primary.contrastText' }}>
                        Data Processing Agreement
                    </Typography>
                    <Typography variant="h6" sx={{ opacity: 0.95, color: 'primary.contrastText' }}>
                        For our business customers and partners
                    </Typography>
                </Box>
            </HeroSection>

            <Container maxWidth="md" sx={{ py: 8 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>1. Scope and Applicability</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    This Data Processing Agreement ("DPA") applies to all processing of personal data by Flux IT Studio LTD on behalf of its customers ("Customer"). This DPA is incorporated into the Flux ERP Terms of Service.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>2. Processing of Personal Data</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    Flux IT Studio LTD shall process personal data only on documented instructions from the Customer, unless required to do so by UK or EU law.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>3. Technical and Organizational Measures</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    We implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk, including encryption, access controls, and regular security testing.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>4. Sub-processors</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    The Customer provides a general authorization for Flux IT Studio LTD to engage sub-processors (e.g., cloud hosting providers) for the purposes of providing the service. We ensure all sub-processors are bound by data protection obligations no less onerous than those in this DPA.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>5. Data Subject Rights</Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                    Taking into account the nature of the processing, Flux IT Studio LTD shall assist the Customer by appropriate technical and organizational measures for the fulfillment of the Customer's obligation to respond to requests for exercising Data Subject rights under UK GDPR.
                </Typography>

                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>6. Termination and Deletion</Typography>
                <Typography variant="body1" color="text.secondary">
                    Upon termination of the service, we shall delete or return all personal data to the Customer, unless required by law to store the personal data.
                </Typography>
            </Container>
        </WebsiteLayout>
    );
};

export default DPAPage;
